import { render } from "./articleHead.vue?vue&type=template&id=9486fc7e&scoped=true"
import script from "./articleHead.vue?vue&type=script&lang=js"
export * from "./articleHead.vue?vue&type=script&lang=js"

import "./articleHead.vue?vue&type=style&index=0&id=9486fc7e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/blog/blog/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9486fc7e"]])

export default __exports__